import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'nsnNumber',
     field: FIELDS.NSNNUMBER,
     title: 'NSN',
     label: 'NSN',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'harmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: 'HTS',
     label: 'HTS',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'scheduleB',
     field: FIELDS.SCHEDULE_B,
     title: 'Schedule B',
     label: 'Schedule B',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'eccn',
     field: FIELDS.ECCN,
     title: 'ECCN',
     label: 'ECCN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'uom',
     field: FIELDS.UOM,
     title: 'UOM',
     label: 'UOM',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Item Pkg',
     label: 'Item Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'physPkg',
     field: FIELDS.PHYS_PKG,
     title: 'Phys Pkg',
     label: 'Phys Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantitySold',
     field: FIELDS.QUANTITY_SOLD,
     title: 'Line Sold',
     label: 'Line Sold',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'quantityBackordered',
     field: FIELDS.QUANTITY_BACKORDERED,
     title: 'Line Backorder',
     label: 'Line Backorder',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'quantityInbound',
     field: FIELDS.QUANTITY_INBOUND,
     title: 'Line Inbound',
     label: 'Line Inbound',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'quantity',
     field: FIELDS.QUANTITY,
     title: 'Line Quantity',
     label: 'Line Quantity',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'quantityScheduled',
     field: FIELDS.QUANTITY_SCHEDULED,
     title: 'Qty Scheduled',
     label: 'Qty Scheduled',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'quantityAllocated',
     field: FIELDS.QUANTITY_ALLOCATED,
     title: 'Line Allocated',
     label: 'Line Allocated',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantityInTesting',
     field: FIELDS.QUANTITY_IN_TESTING,
     title: 'Line In Testing',
     label: 'Line In Testing',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantityShipped',
     field: FIELDS.QUANTITY_SHIPPED,
     title: 'Line Shipped',
     label: 'Line Shipped',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'quantityReturned',
     field: FIELDS.QUANTITY_RETURNED,
     title: 'Line Returned',
     label: 'Line Returned',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'quantityScheduleShipped',
     field: FIELDS.QUANTITY_SCHEDULE_SHIPPED,
     title: 'Qty Schedule Shipped',
     label: 'Qty Schedule Shipped',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'quantityScheduleReturned',
     field: FIELDS.QUANTITY_SCHEDULE_RETURNED,
     title: 'Qty Schedule Returned',
     label: 'Qty Schedule Returned',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'actualQuantityScheduled',
     field: FIELDS.ACTUAL_QUANTITY_SCHEDULED,
     title: 'Actual Qty Scheduled',
     label: 'Actual Qty Scheduled',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'customerDueDate',
     field: FIELDS.CUSTOMER_DUE_DATE,
     title: 'Due Date',
     label: 'Due Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'scheduledShipDate',
     field: FIELDS.SCHEDULED_SHIP_DATE,
     title: 'Scheduled Ship Date',
     label: 'Scheduled Ship Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'actualShipDate',
     field: FIELDS.ACTUAL_SHIP_DATE,
     title: 'Actual Ship Date',
     label: 'Actual Ship Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'customerDockDate',
     field: FIELDS.CUSTOMER_DOCK_DATE,
     title: 'Dock Date',
     label: 'Dock Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'returnedDate',
     field: FIELDS.RETURNED_DATE,
     title: 'Returned Date',
     label: 'Returned Date',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shippingProviderName',
     field: FIELDS.SHIPPING_PROVIDER_NAME,
     title: 'Ship Via',
     label: 'Ship Via',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shippingMethodName',
     field: FIELDS.SHIPPING_METHOD_NAME,
     title: 'Ship Method',
     label: 'Ship Method',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'salesOrderShipMethod',
     field: FIELDS.SALES_ORDER_SHIP_METHOD,
     title: 'SO Ship Method',
     label: 'SO Ship Method',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingAccountNumber',
     field: FIELDS.SHIPPING_ACCOUNT_NUMBER,
     title: 'Ship Acct No',
     label: 'Ship Acct No',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingDays',
     field: FIELDS.SHIPPING_DAYS,
     title: 'Shipping Days',
     label: 'Shipping Days',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'bringIn',
     field: FIELDS.BRING_IN,
     title: 'Bring In',
     label: 'Bring In',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'lotCode',
     field: FIELDS.LOT_CODE,
     title: 'Lot',
     label: 'Lot',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'revision',
     field: FIELDS.REVISION,
     title: 'Revision',
     label: 'Revision',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'countryOfOriginName',
     field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
     title: 'COO',
     label: 'COO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'condition',
     field: FIELDS.CONDITION,
     title: 'Condition',
     label: 'Condition',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'leadFree',
     field: FIELDS.LEAD_FREE,
     title: 'RoHS',
     label: 'RoHS',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'testingRequested',
     field: FIELDS.TESTING_REQUESTED,
     title: 'Testing Rqstd',
     label: 'Testing Rqstd',
     cell: 'checkMArk',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'mfgName',
     field: FIELDS.MFG_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'className',
     field: FIELDS.CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'categoryName',
     field: FIELDS.CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'customerPo',
     field: FIELDS.CUSTOMER_PO,
     title: 'Customer PO',
     label: 'Customer PO',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
